<template>
    <div class="modalwrapper">
        <div v-if="!exiting">
            <h1>Exit accrolab?</h1>
            Do you really want to abort operation and exit accrolab?
            <div class="buttons">
                <button @click="$emit('close')">Cancel</button>
                <button @click="exit">Abort and Exit</button>
            </div>
        </div>
        <div v-else>
            <h1>Shutting down...</h1>
            <div class="spinner">
                <loading/>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    methods: {
        exit(){
            this.exiting = true;
            this.$api.call('status.exit');
        }
    },
    components: {
        
    },
    mounted(){
       
    },
    props: [
    ],
    data: function(){
        return {
            exiting: false
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    .spinner {
        margin: auto;
        font-size: 50px;
        margin-top: -50px;
    }
    .buttons {
        position: absolute;
        bottom: 0;
        padding: 10px;
        width: 100%;
    }
    button {
        width: 49%;
        box-shadow: 2px 2px 5px 0px $accromagrey;
        &:hover:not([disabled]) {
            background-color: $accromabluehue;
        }
    }
</style>
